import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
const Spinner = lazy(() => import('ui-connect/Spinner/Spinner'));

const AccountSharingIndex = () => {
    // have to inject the global style due to the privacy-overlay,
    // we are don't need it on loading screen
    const LandingPage = () => {
        return (
            <div
                style={{
                    display: 'grid',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    height: '100vh',
                    width: '100vw',
                    alignContent: 'center',
                    justifyContent: 'center'
                }}
            >
                <style>
                    {`.privacy-overlay {
                            display: none;
                        }`}
                </style>
                <Suspense fallback={null}>
                    <Spinner size="default" />
                </Suspense>
            </div>
        );
    };
    const container = document.querySelector('.content');
    if (container === null) {
        return;
    }
    const root = createRoot(container);
    root.render(<LandingPage />);
};

export default AccountSharingIndex;
